/* eslint-disable no-unused-vars */
import {
  Hero,
  About,
  Testimonial,
  TestimonialsGrid,
  Process,
  FeaturedProjects,
  Faq,
} from "../components";

const HomePage = () => {
  return (
    <>
      <Hero />
      <Testimonial />
      <Process />
      <FeaturedProjects />
      <About />
      <TestimonialsGrid />
      <Faq />
    </>
  );
};

export default HomePage;
